export default __webpack_public_path__ + "static/cake-5faf203db2d29c53b3158593670f6ea5.jpg";